export default __webpack_public_path__ + "static/media/TripAdvisor.9f380eb4.svg";